import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';

//import { EnvService } from 'src/app/env.service';
//import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
//import { ApiEndPointsNotification } from 'src/app/services/commonUtility/apiUrls/api-end-points-notification';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { GenericApiService } from '@pm-ui/core-services';

@Injectable({
  providedIn: 'root'
})

export class HubConnection {
  hubConnection: any; 
  private hubConnection2: any
  newChatRecived = new Subject<any>();
  newGroupCreated = new Subject<any>();
  userRemoved = new Subject<any>();

  constructor(private _http: HttpClient,private apiService : GenericApiService) {    
    this.createHubConnection = this.createHubConnection.bind(this);
  }

  createHubConnection = () => { 
    debugger
    if(this.hubConnection==null || this.hubConnection==undefined)
    {
      const apiURL = this.apiService.getBaseAPIUrl() + '/chat';
      //const apiURL= "https://ms.stagingsdei.com:9018"+ '/chat';
      //const apiURL= "https://property.jape.com.au:9018"+ '/chat';
      //const apiURL = "http://localhost:22076" + '/chat';
      this.hubConnection = new signalR.HubConnectionBuilder().withUrl(apiURL+'?diag=yes').build();
      //this.hubConnection = new HubConnection('http://localhost:22076/chat');

      this.hubConnection
      .start()
      .then(() => console.log('Connection started!'))
      .catch(() => console.log('Error while establishing connection :('));
      
      // this.hubConnection.start().then(() => {
      //  }).catch(() => console.log('Error while establishing connection'));
  
       this.hubConnection.on('messageRecieved', (data: any) => {     
        this.newChatRecived.next(data);    
      });
   

    // this.hubConnection.on('taskAdded', (data:any) => { 
    //   this.newGroupCreated.next(data);
    // });

    // this.hubConnection.on('userRemoved', (data) => { 
    //   this.userRemoved.next(data);
    // });
  }
  };

  getHubConnection() {
    return this.hubConnection;
  }

  // restartHubConnection() {
  //   let self = this;
  //   return new Promise((resolve, reject) => {
  //     if (self.isDisconnected()) {
  //       self.hubConnection
  //         .start()
  //         .then((hubConnection) => {
  //           resolve(hubConnection);
  //         })
  //         .catch((err) => {          
  //           reject(err);
  //         });
  //      }
  //   });
  // }
  

  isConnected() {
    return(this.hubConnection && this.hubConnection.connection.connectionState === 1);
  }

  isDisconnected() {
    return(this.hubConnection && this.hubConnection.connection.connectionState === 2);
  }
  
  // ConnectToServerWithUserId(userId: number, roomId: number) {
  //   var room = this.hubConnection.invoke("Connect", userId, roomId);
  //   return room;
  // }

  // ConnectWithAccessToken() {
  //   var room = this.hubConnection.invoke("ConnectWithAccessToken");
  //   return room;
  // }

  // ConnectWithBussinessToken(userId: number) {
  //   var room = this.hubConnection.invoke("ConnectWithBussinessToken", userId);
  //   return room;
  // }

 

  // ===========================TaskCommunicationHub======================================
  startConnection() {
    // Check if the connection is already established
    if (this.hubConnection2 && this.hubConnection2.state === 'Connected') {
      console.log('Connection already established.');
      return;
    }

    // Initialize the connection if it's not already established
    this.hubConnection2 = new signalR.HubConnectionBuilder()
      .withUrl(this.apiService.getBaseAPIUrl()+"/TaskUpdate")      
    .build();


    this.hubConnection2.onclose(async () => {
      console.error('Disconnected. Attempting to reconnect...');
      setTimeout(async () => {
          try {
              await this.hubConnection2.start();
              console.log('Reconnected!');
          } catch (err) {
              console.error('Reconnection failed:', err);
          }
      }, 5000); // Retry after 5 seconds
  });

    this.hubConnection2
      .start()
      .then(() => console.log('SignalR connection established'))
      .catch((err:any) => console.error('Error establishing connection: ', err));
  }

  addReceiveIdListener(callback: (id: any) => void) {
    if (!this.hubConnection2) return;
    this.hubConnection2.on('TaskId', callback);
  }

}
